
  import { mapEntityProperties } from '@/utils/mapEntityProperties'
  import { AuthenticationEntity } from '../../domain/entities/AuthenticationEntity'
  export class AuthenticationModel extends AuthenticationEntity {
  constructor(dataDto) {
    super()
    mapEntityProperties(this, dataDto)
  }
}